/* istanbul ignore file: todo tests @titk */

/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/unbound-method */
import React, {CSSProperties, memo} from 'react';
import _ from 'lodash';
import a11y from '@wix/wixstores-client-core/dist/es/src/assets/styles/_accessibility.scss';
import {classes as quantityStyle, style as styleQuantity} from './QuantityCounter.st.css';
import autobind from 'auto-bind-es5';
import classNames from 'classnames';
import s from './ProductItem.scss';
import {classes as productItemStylable, st as productItemStyles} from './ProductItem.st.css';
import {Counter, Text} from '@wix/wix-ui-tpa/cssVars';
import {IGalleryGlobalProps} from '../../../gallery/galleryGlobalStrategy';
import {ButtonContentType, IProduct, ProductItemsState, RibbonPlacementId} from '../../../types/galleryTypes';
import {ProductPrice} from './ProductPrice/ProductPrice';
import {QuantityCalculator} from '@wix/wixstores-client-core/dist/es/src/quantity-calculator/quantityCalculator';
import {withGlobals} from '../../../globalPropsContext';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {ProductOptionsChangeData, ProductOptions} from './ProductOptions/ProductOptions';
import {ProductOptionType} from '@wix/wixstores-graphql-schema';
import {ProductRibbon} from './Ribbon/Ribbon';
import {AddToCartButton as AddToCart} from './AddToCartButton/AddToCartButton';
import {RepeatedSlotsPlaceholder, SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import {SlotContextProvider} from '@wix/widget-plugins-ooi-context';
import {AddToCartActionStatus, Experiments, ProductBorderStyleType, ProductItemSlotIds} from '../../../constants';
import {ConditionalRender} from '../ConditionalRender/ConditionalRender';
import {ImageLinkContainer} from './ImageLinkContainer/ImageLinkContainer';
import {canAddProductToCart, isAddToCartEnabled, shouldRenderOutOfStock} from './productItemUtils';
import {ProductDiscountRuleName} from './ProductDiscountRuleName/ProductDiscountRuleName';
import {ProductTaxDisclaimer} from './ProductTaxDisclaimer/ProductTaxDisclaimer';
import {ProductBasePrice} from './ProductBasePrice/ProductBasePrice';
import {getProductVariantBySelectionIds} from '@wix/wixstores-client-core/dist/es/src/productVariantCalculator/ProductVariantCalculator';
import {LazyProductQuickAdd} from './ProductQuickAdd/LazyProductQuickAdd';

export enum DataHook {
  Root = 'product-item-root',
  QuickViewButton = 'product-item-quick-view-button',
  LineBetweenNameAndPrice = 'product-item-line-between-name-and-price',
  Name = 'product-item-name',
  Price = 'product-item-price',
  BasePriceComponent = 'base-price-component',
  NameAndPriceLayout = 'product-item-name-and-price-layout',
  ProductDetails = 'product-item-product-details',
  ProductDetailsLink = 'product-item-product-details-link',
  QuantityCounter = 'product-item-quantity-counter',
  QuantityCounterWrapper = 'product-item-quantity-counter-wrapper',
  Ribbon = 'product-item-ribbon',
  SrOnlyName = 'product-item-sr-only-name',
  Options = 'product-item-options',
  NotImageContainer = 'not-image-container',
  SlotsPlaceholderContainer = 'slots-placeholder',
  OutOfStock = 'product-item-out-of-stock',
  OutOfStockTextContainer = 'out-of-stock-text-container',
  QuickAddInsideProductInfo = 'quick-add-inside-product-info',
}

export interface IProductItemProps extends IGalleryGlobalProps {
  announce: (content: string) => void;
  index: number;
  product: IProduct;
  innerRef?: Function;
  disabled?: boolean;
  style?: CSSProperties;
  className?: string;
}

interface IProductItemState {
  errors: {quantity?: string};
  limits: {quantity: {min: number; max: number}};
  selections: number[];
  quantity: number;
  showHoverPreview: boolean;
  isVisualLoading: boolean;
}

const PREVIEW_DURATION = 1000;
const LOADER_DELAY = 500;
let timeOutId;

const Slot = memo<{resourceId: string; slotId: string; repeated: boolean}>(({resourceId, slotId, repeated}) =>
  repeated ? (
    <RepeatedSlotsPlaceholder
      slotId={slotId}
      repeatedItemId={resourceId}
      data-hook={`${DataHook.SlotsPlaceholderContainer}-${slotId}`}
    />
  ) : (
    <SlotContextProvider resourceId={resourceId}>
      <SlotsPlaceholder slotId={slotId} data-hook={`${DataHook.SlotsPlaceholderContainer}-${slotId}`} />
    </SlotContextProvider>
  )
);

export class ProductItem extends React.Component<IProductItemProps & IProvidedTranslationProps, IProductItemState> {
  private readonly debouncedStopHoverPreview = _.debounce(
    () => this.setState({showHoverPreview: false}),
    PREVIEW_DURATION
  );

  private readonly delayIsProductItemsLoading = () => {
    timeOutId = setTimeout(() => {
      this.setState({isVisualLoading: this.isProductItemsFetching});
    }, LOADER_DELAY);
  };

  private readonly productLink = React.createRef<HTMLAnchorElement>();
  private readonly rootRef = React.createRef<HTMLDivElement>();

  public state: IProductItemState = {
    showHoverPreview: false,
    quantity: 1,
    isVisualLoading: false,
    selections: [],
    errors: {quantity: undefined},
    limits: {
      quantity: {
        min: 1,
        max: 1,
      },
    },
  };

  private hoverType: string;

  constructor(props) {
    super(props);
    autobind(this);

    const {styles, stylesParams} = this.props.globals;
    this.hoverType = styles.get(stylesParams.gallery_hoverType).value;
  }

  public static getDerivedStateFromProps(
    props: IProductItemProps,
    state: IProductItemState
  ): Partial<IProductItemState> {
    const userOptionSelections = state.selections.map((selectionId) => {
      return {id: selectionId};
    });
    const inventoryRange = QuantityCalculator.getQuantitiesRange(props.product, userOptionSelections);
    const inventoryCount = inventoryRange[inventoryRange.length - 1];

    return {
      limits: {
        quantity: {
          min: 1,
          max: inventoryCount,
        },
      },
    };
  }

  public focus(): void {
    this.productLink.current.focus();
  }

  private renderSrOnlyName() {
    return (
      <span data-hook={DataHook.SrOnlyName} className={a11y.srOnly}>
        {this.props.product.name}
      </span>
    );
  }

  private renderName() {
    const {
      product,
      globals: {shouldShowMobile},
    } = this.props;

    const htmlTag = this.props.globals.htmlTags.productNameHtmlTag;
    const classes = classNames(
      productItemStyles(productItemStylable.root, {
        useMobileFont: shouldShowMobile,
      }),
      s.productName
    );

    return (
      <Text tagName={htmlTag} className={classes} data-hook={DataHook.Name}>
        {product.name}
      </Text>
    );
  }

  private renderPrice() {
    const {
      globals: {
        allowFreeProducts,
        textsMap: {
          productPriceBeforeDiscountSR,
          productOutOfStockText,
          productPriceAfterDiscountSR,
          productPriceWhenThereIsNoDiscountSR,
          measurementUnits,
          pricePerUnitSR,
        },
        experiments: {shouldUseCommonDiscountPricingMethods},
      },
    } = this.props;

    const textsMap = {
      productPriceBeforeDiscountSR,
      productOutOfStockText,
      productPriceAfterDiscountSR,
      productPriceWhenThereIsNoDiscountSR,
      measurementUnits,
      pricePerUnitSR,
    };

    return (
      <ProductPrice
        product={this.productWithPriceInfo}
        selectedProductVariant={this.selectedProductVariant}
        allowFreeProducts={allowFreeProducts}
        textsMap={textsMap}
        shouldUseCommonDiscountPricingMethods={shouldUseCommonDiscountPricingMethods}
        fromPrice={this.productPriceRange}
      />
    );
  }

  private renderOutOfStock() {
    const {
      product,
      globals: {
        textsMap: {productOutOfStockText},
        useExperiments,
        stylesParams,
      },
    } = this.props;
    const shouldEnableOutOfStockAlignment = useExperiments.enabled(Experiments.EnableOutOfStockAlignment);
    const shouldRenderOutOfStockLayout = shouldRenderOutOfStock(product);
    const isShowingOutOfStockMessage =
      !this.props.globals.styles.get(stylesParams.gallery_showAddToCartButton) ||
      this.props.globals.styles.get(stylesParams.gallery_addToCartButtonContentType) === ButtonContentType.Icon;

    if (shouldRenderOutOfStockLayout) {
      return (
        <ConditionalRender
          by={'notShowAddToCartButtonOrIconOnlyButton'}
          dataHook={DataHook.OutOfStockTextContainer}
          className={classNames({[s.outOfStockTextContainer]: shouldEnableOutOfStockAlignment})}>
          <span
            data-hook={DataHook.OutOfStock}
            className={classNames(s.outOfStock, {
              [s.outOfStockColorWhenNoButtonOrIconOnlyButton]: isShowingOutOfStockMessage,
            })}>
            {productOutOfStockText}
          </span>
        </ConditionalRender>
      );
    }
    return null;
  }

  private static renderLineBetweenNameAndPrice() {
    return (
      <div className={s.productDividerWrapper}>
        <hr data-hook={DataHook.LineBetweenNameAndPrice} className={s.productDivider} aria-hidden="true" />
      </div>
    );
  }

  private renderProductInfoRibbon() {
    const {
      product: {ribbon},
      globals: {shouldShowMobile},
    } = this.props;

    return (
      <ProductRibbon shouldShowMobile={shouldShowMobile} ribbon={ribbon} placement={RibbonPlacementId.ProductInfo} />
    );
  }

  private handleQuantityCounterChange(val: string) {
    const {t} = this.props;
    const {min, max} = this.state.limits.quantity;
    const quantity = parseInt(val, 10) || 0;

    const minimumError = quantity < min && t('quantityMinimumAmountSR', {minimum: min});
    const maximumError = quantity > max && t('quantityMaximumAmountSR', {inventory: max});

    this.setState(
      ({errors}) => {
        const nextErrors = {...errors, quantity: minimumError || maximumError};
        return {quantity, errors: nextErrors};
      },
      () => {
        if (this.state.errors.quantity) {
          this.props.announce?.(this.state.errors.quantity);
        } else {
          this.props.announce?.(
            this.props.t('quantityTotalSR', {
              quantity,
            })
          );
        }
      }
    );
  }

  private readonly handleSelectionsChange = (selections: number[], data: ProductOptionsChangeData) => {
    const newState = {selections, quantity: 1};
    this.setState(newState, () => {
      const {
        props: {
          globals: {handleProductsOptionsChange, productsManifest},
          product: {id: productId},
        },
      } = this;
      const {optionType} = data;
      if (productsManifest[productId].productItemsState === ProductItemsState.MISSING) {
        this.delayIsProductItemsLoading();
      }
      void handleProductsOptionsChange({
        productId,
        selectionIds: selections,
        optionType,
      });
    });
  };

  private handleProductItemClick(event: React.MouseEvent<HTMLAnchorElement>) {
    const {
      globals: {handleProductItemClick, reportProductItemClick, productsManifest},
      product: {id: productId},
      index,
      disabled,
    } = this.props;

    const shouldOpenInNewTab = event.ctrlKey || event.metaKey;
    if (shouldOpenInNewTab && !disabled) {
      reportProductItemClick({
        productId,
        index,
      });
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const isProductQuickAddIsOpen = productsManifest[productId].productItemsState === ProductItemsState.QUICK_ADD;
    if (disabled || isProductQuickAddIsOpen) {
      return;
    }

    handleProductItemClick({
      biData: {
        productId,
        index,
      },
    });
  }

  public componentDidUpdate(prevProps: Readonly<IProductItemProps>): void {
    const {
      product,
      globals: {addedToCartStatus: prevAddedToCartStatus},
    } = prevProps;
    const {
      globals: {addedToCartStatus, shouldShowAddToCartSuccessAnimation, stylesParams},
      announce,
      t,
    } = this.props;

    const previousHoverType = this.hoverType;
    const currentHoverType = this.props.globals.styles.get(stylesParams.gallery_hoverType).value;
    this.hoverType = currentHoverType;

    if (previousHoverType !== currentHoverType) {
      this.setState({showHoverPreview: true});
      this.debouncedStopHoverPreview();
    }
    if (!this.isProductItemsFetching && this.state.isVisualLoading) {
      this.setState({isVisualLoading: false});
    }

    const prevAddToCartStatus = prevAddedToCartStatus[product.id];
    const addToCartStatus = addedToCartStatus[product.id];

    if (
      shouldShowAddToCartSuccessAnimation &&
      prevAddToCartStatus !== AddToCartActionStatus.SUCCESSFUL &&
      addToCartStatus === AddToCartActionStatus.SUCCESSFUL
    ) {
      announce(t('addToCartSuccessSR', {productName: product.name}));
      this.onAddToCartClicked();
    }
  }

  public componentWillUnmount() {
    clearTimeout(timeOutId);
  }

  private get selectedProductVariant() {
    const {product} = this.props;
    const variantSelectionIds =
      this.productVariantInfo /* istanbul ignore next: todo tests @titk */?.variantSelectionIds;

    return product && variantSelectionIds
      ? getProductVariantBySelectionIds({
          product,
          variantSelectionIds,
        })
      : undefined;
  }

  private get productVariantInfo() {
    const {
      globals: {productsVariantInfoMap},
      product,
    } = this.props;

    return productsVariantInfoMap?.[product.id];
  }

  private get productWithPriceInfo() {
    const {
      globals: {productsManifest},
      product,
    } = this.props;

    return canAddProductToCart(product, productsManifest)
      ? {
          ...product,
          ...this.productVariantInfo /* istanbul ignore next: todo tests @titk */?.priceInfo,
        }
      : product;
  }

  private get productPriceRange(): string | undefined {
    const {
      globals: {productsPriceRangeMap},
      product,
    } = this.props;

    return productsPriceRangeMap?.[product.id];
  }

  private readonly renderQuantityCounter = () => {
    const {
      globals: {shouldShowMobile, textsMap, useExperiments},
    } = this.props;

    const {
      quantity,
      limits: {
        quantity: {min, max},
      },
    } = this.state;

    const errors = {
      error: !!this.state.errors.quantity,
      errorMessage: this.state.errors.quantity,
    };
    const shouldUseNewMargin = this.props.globals.useExperiments.enabled(
      Experiments.EnableQualityOptionsStylingChanges
    );
    const shouldAllowCustomProductOptionsAndQuantityWidth = useExperiments.enabled(
      Experiments.GalleryProductOptionsAndQuantityWidth
    );

    const getQuantityClass = (isNewMargin: boolean): string => (isNewMargin ? s.quantity : s.oldQuantity);
    return (
      <div
        className={classNames(getQuantityClass(shouldUseNewMargin), {
          [s.quantityAlignment]: shouldAllowCustomProductOptionsAndQuantityWidth,
        })}
        data-hook={DataHook.QuantityCounterWrapper}>
        <Counter
          {...errors}
          aria-label={textsMap.quantityChooseAmountSR}
          inputAriaLabel={textsMap.quantityInputSR}
          onChange={this.handleQuantityCounterChange}
          data-hook={DataHook.QuantityCounter}
          value={quantity}
          min={min}
          max={max}
          className={classNames(
            styleQuantity(quantityStyle.quantityCounter, {
              customized: true,
              separateStyles: true,
            }),
            {
              [s.showOnHover]: !shouldShowMobile,
              [s.quantityWidth]: shouldAllowCustomProductOptionsAndQuantityWidth,
            }
          )}
        />
      </div>
    );
  };

  public renderOptions = () => {
    const {product} = this.props;
    return (
      <div data-hook={DataHook.Options}>
        <ProductOptions
          variantsAvailability={this.productVariantInfo.selectionsAvailability}
          onSelectionIdsChange={this.handleSelectionsChange}
          product={product}
          selectionIds={this.productVariantInfo.variantSelectionIds}
          isLoading={this.state.isVisualLoading}
          readOnly={this.isProductItemsFetching}
        />
      </div>
    );
  };

  public onAddToCartClicked = () => {
    this.setState({quantity: 1});
  };

  private readonly renderAddToCartButton = () => {
    const {quantity} = this.state;
    const {product, index} = this.props;

    return <AddToCart product={product} index={index} quantity={quantity} showOnHoverClassName={s.showOnHover} />;
  };

  private handleQuickViewButtonClick(event: React.MouseEvent<HTMLButtonElement>) {
    const {
      globals: {openQuickView},
      product: {id: productId},
      index,
    } = this.props;
    const {quantity} = this.state;
    const selectionIds = this.productVariantInfo?.variantSelectionIds || [];

    event.preventDefault();
    event.stopPropagation();

    openQuickView({productId, index, selectionIds, quantity});
  }

  private renderQuickViewButton() {
    const {
      textsMap: {quickViewButtonText},
    } = this.props.globals;

    return (
      <button
        type="button"
        className={s.quickViewButton}
        data-hook={DataHook.QuickViewButton}
        onClick={this.handleQuickViewButtonClick}>
        {quickViewButtonText}
      </button>
    );
  }

  private get isProductItemsFetching(): boolean {
    const {
      globals: {productsManifest},
    } = this.props;

    return productsManifest[this.props.product.id].productItemsState === ProductItemsState.LOADING;
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public render() {
    const {index, globals, product, style, t} = this.props;
    const {
      shouldShowMobile,
      shouldShowProductOptions,
      isLiveSiteMode,
      isPreviewMode,
      productsManifest,
      styles,
      stylesParams,
      experiments,
      useExperiments,
    } = globals;
    const {isAllowGalleryProductRoundCornersInViewer} = experiments;

    const shouldOmitFlexGrow = useExperiments.enabled(Experiments.EnableQualityOptionsStylingChanges);
    const isAddToCartButtonOnImageAllowedInViewer = useExperiments.enabled(
      Experiments.AllowAddToCartButtonOnImageInViewer
    );
    const isRepeatedSlotsEnabled = useExperiments.enabled(Experiments.RepeatedSlots);

    const productManifest = productsManifest[product.id];

    if (!productManifest) {
      return null;
    }

    const {showHoverPreview} = this.state;
    const options = this.props.product.options;
    const noOptions = options.length === 0;
    const singleOption = options.length === 1;
    const multipleColorOptions = !noOptions && options.every(({optionType}) => optionType === ProductOptionType.COLOR);
    const productPageUrl = productManifest.url;
    const ariaLabelBase = product.name;
    const ariaLabel = product.ribbon ? `${ariaLabelBase}. ${product.ribbon}` : ariaLabelBase;

    const isQuickBuyViewerExperimentEnabled = useExperiments.enabled(Experiments.GalleryQuickBuyViewer);
    const isQuickAddOpen =
      isQuickBuyViewerExperimentEnabled && productManifest.productItemsState === ProductItemsState.QUICK_ADD;

    const borderStyle = styles.get(stylesParams.gallery_productBorderStyleType);

    const getDetailsContainerClass = (): string =>
      shouldOmitFlexGrow ? s.productDetailsContainer : s.oldProductDetailsContainer;

    return (
      <div
        data-slug={product.urlPart}
        role="group"
        aria-label={t('carouselContainerLabel', {productName: ariaLabel})}
        style={style}
        ref={this.rootRef}
        data-hook={DataHook.Root}
        className={classNames(
          this.props.className,
          s.productItem,
          borderStyle === ProductBorderStyleType.INLINE ? s.inlineBorder : s.outline,
          {
            [s.hoverPreview]: showHoverPreview,
            [s.roundCorners]: isAllowGalleryProductRoundCornersInViewer,
            [s.oddProductItem]: index % 2,
          }
        )}>
        <ImageLinkContainer
          index={index}
          product={product}
          showHoverPreview={showHoverPreview}
          renderAddToCartButton={this.renderAddToCartButton}
          renderQuickViewButton={this.renderQuickViewButton}
          handleProductItemClick={this.handleProductItemClick}
          quantity={this.state.quantity}
          productItemRef={this.rootRef}
          isQuickAddOpen={isQuickAddOpen}
        />
        <div data-hook={DataHook.NotImageContainer} className={s.notImageContainer}>
          <div className={getDetailsContainerClass()}>
            <a
              href={isLiveSiteMode || isPreviewMode ? productPageUrl : null}
              onClick={this.handleProductItemClick}
              className={classNames({[s.productDetailsLink]: !shouldOmitFlexGrow})}
              data-hook={DataHook.ProductDetailsLink}
              ref={this.productLink}>
              <ConditionalRender by={'notShowProductName'}>{this.renderSrOnlyName()}</ConditionalRender>
              <ConditionalRender by={'showProductDetails'}>
                <div className={s.productDetails} data-hook={DataHook.ProductDetails}>
                  {product.ribbon && (
                    <ConditionalRender by={'shouldShowRibbonOnProductInfo'} className={s.ribbonContainer}>
                      {this.renderProductInfoRibbon()}
                    </ConditionalRender>
                  )}
                  <div className={s.namePriceLayout} data-hook={DataHook.NameAndPriceLayout}>
                    <ConditionalRender by={'gallery_showProductName'}> {this.renderName()}</ConditionalRender>
                    <ConditionalRender by={'showDivider'}>
                      {ProductItem.renderLineBetweenNameAndPrice()}
                    </ConditionalRender>
                    <ConditionalRender by={'gallery_showPrice'} className={s.priceContainer}>
                      {this.renderPrice()}
                    </ConditionalRender>
                  </div>

                  <ConditionalRender by={'gallery_showPrice'} className={s.priceContainer}>
                    {this.renderOutOfStock()}
                    <ProductBasePrice product={this.productWithPriceInfo} />
                    <ConditionalRender by={'gallery_showDiscountName'} className={s.discountName}>
                      <ProductDiscountRuleName product={product} />
                    </ConditionalRender>
                    <ProductTaxDisclaimer product={product} />
                  </ConditionalRender>
                </div>
              </ConditionalRender>
            </a>
            <div className={s.slotContainer}>
              <Slot resourceId={product.id} slotId={ProductItemSlotIds.ProductGalleryDetailsSlot1} repeated={false} />
            </div>
            {canAddProductToCart(product, productsManifest) && shouldShowProductOptions && (
              <ConditionalRender
                by={shouldShowMobile ? 'mobile:gallery_showProductOptions' : 'gallery_showProductOptionsButton'}
                className={s.productInputs}>
                {this.renderOptions()}
              </ConditionalRender>
            )}
            {isAddToCartEnabled(product, productsManifest) && (
              <div>
                <ConditionalRender
                  by={shouldShowMobile ? 'mobile:gallery_showAddToCartButton' : 'gallery_showAddToCartButton'}>
                  <ConditionalRender
                    by={shouldShowMobile ? 'mobile:gallery_showQuantity' : 'gallery_showAddToCartQuantity'}>
                    {noOptions && this.renderQuantityCounter()}
                    {(singleOption || multipleColorOptions) && (
                      <ConditionalRender
                        by={
                          shouldShowMobile ? 'mobile:gallery_showProductOptions' : 'gallery_showProductOptionsButton'
                        }>
                        {this.renderQuantityCounter()}
                      </ConditionalRender>
                    )}
                  </ConditionalRender>
                </ConditionalRender>
              </div>
            )}
          </div>
          {isAddToCartButtonOnImageAllowedInViewer ? (
            <div className={s.productFooter}>
              <ConditionalRender by={'showAddToCartInProductInfo'}>{this.renderAddToCartButton()}</ConditionalRender>
              <Slot
                resourceId={product.id}
                slotId={ProductItemSlotIds.GalleryItemAdditionalButtons}
                repeated={isRepeatedSlotsEnabled}
              />
            </div>
          ) : (
            <ConditionalRender
              by={shouldShowMobile ? 'mobile:gallery_showAddToCartButton' : 'gallery_showAddToCartButton'}
              className={s.productFooter}>
              {this.renderAddToCartButton()}
            </ConditionalRender>
          )}
        </div>
        {isQuickAddOpen && (
          <ConditionalRender by="showProductQuickAddInProductInfo" className={s.productQuickAddInProductInfoWrapper}>
            <div className={s.productQuickAddInProductInfoContainer} data-hook={DataHook.QuickAddInsideProductInfo}>
              <LazyProductQuickAdd
                product={product}
                productIndex={index}
                productItemRef={this.rootRef}
                quantity={this.state.quantity}
              />
            </div>
          </ConditionalRender>
        )}
      </div>
    );
  }
}

export const ProductItemWithGlobals: React.FC<IProductItemProps & IProvidedTranslationProps> = withGlobals(
  withTranslations()(ProductItem)
);
